import axios from 'axios';
import { getAPIHost } from '../../utils';

const uploadPaymentSheet = (formData, type, year, month) =>
    new Promise((resolve, reject) => {
        axios
            .post(`${getAPIHost()}/upload-monthly-report/${type}/${year}/${month}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch(() => {
                reject(new Error('Unable to upload file. Please contact support.'));
            });
    });

export default uploadPaymentSheet;
